module.exports = __webpack_public_path__ + "img/16.dd17fa34.jpg";